import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { AppStorageService, ConfirmDialogService, JReportDataService, KEYS_APPSTORAGE, ResourceService, sceconfig, UserService } from 'sce-core';
import { NavigationService } from 'sce-core';
import { TokenService } from 'sce-core';
import { SessionTimerService } from 'sce-core';

declare var window: any;
import { LeftPanelService } from './services/left-panel.service';
import { HomeService } from './home.service';
import { ActivatedRoute } from '@angular/router';
import { PrinterSetupComponent } from 'sce-home';
import { ModalService, DatePickerConfigService } from 'sce-ui-lib';
import { DashboardService } from 'sce-core/dashboard.service';
import { MaintenanceNoticePopupComponent } from 'sce-admin/downtime-configuration/popup/maintenance-notice-popup/maintenance-notice-popup.component';
import { UserInfo } from 'sce-core/models/user-info.model';
import * as moment from 'moment';
import { gb } from 'sce-core';
import { HttpClient } from '@angular/common/http';
import { CoreServiceRegistry } from '../../core/core-service-registry';
import { environment } from '../../../environments/environment';
import { MfaNotificationPopupComponent } from 'sce-admin/mfa-notification-popup/mfa-notification-popup.component';

@Component({
  selector: 'lfwms-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        marginLeft: '350px',
      })),
      state('closed', style({
        marginLeft: '0px'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  private lastMouseMoveTimeStamp: number = 0;
  private updateFeedsTimer: Subscription;
  private navigationSubscription: Subscription;
  private rssFeedsSubscription: Subscription;
  public carouselImageUrls: string[];
  public rssFeeds: any;
  public isHomePage: boolean = true;
  public showOverlay: boolean = true;private displayCountry: String;
  private displayLanguage: String; 
  private languages: any[]; 
  private countries: any[]; 
  public emailAddress: String = ""; 
  public hiddenField: String = ""; 
  public browser: String = "";  
  private http$: HttpClient;
  public isFeedBackSubmitted: boolean = true;
  public feedbackFormId: string = "";

  private susEnabled: boolean = false; 
  private isTMSFeatureEnabled: boolean = false; 
  private isWMSFeatureEnabled: boolean = false; 
  private isMfaFeatureEnabled: boolean = false;
  @ViewChild('carouselViewport')
  public carouselViewportRef: ElementRef;


  /*  $event.timeStamp::
      Number of milliseconds elapsed since the beginning of the
      current document creation till the occurence of mouse movement. */
  @HostListener('document:mousemove', ['$event'])
  onMouseMove($event: any) {
    if (this.sessionTimerService.isAutoRefreshIntervalActive) {
    const latestMouseMoveTimeStamp: number = Math.floor($event.timeStamp);
      if ((latestMouseMoveTimeStamp - this.lastMouseMoveTimeStamp) > 10000) {
        // lastMouseMoveTimeStamp should be reset to 0
        this.tokenService.refreshToken();
        this.lastMouseMoveTimeStamp = latestMouseMoveTimeStamp;
        
        // refresh logi report session
        this.jreportDataService.checkOrLoginJReport().subscribe(response => {
        //LFWM-2093- updating timeout for jreport
          this.userService.userInfo = response;
          this.jreportDataService.updateJreportTimeOut(sceconfig.wms.jreportTimeOut);
        }, (error) => {
          this.userService.userInfo = this.appStorageService.getItem(KEYS_APPSTORAGE.USER_INFO);
          console.log('jreportlogInStatError', error);
        });
      }
    }
  }

  constructor(private navService: NavigationService,
      private homeService: HomeService,
      private resourceService: ResourceService,
      private tokenService: TokenService,
      private sessionTimerService: SessionTimerService,
      private activatedRoute: ActivatedRoute,
      public leftPanelService: LeftPanelService,
      private modalService: ModalService,
      private dateConfigService: DatePickerConfigService,
      private userService: UserService,
      private dashboardService: DashboardService,
      private dialogService: ConfirmDialogService,
      private appStorageService: AppStorageService,
      private coreServiceRegistry: CoreServiceRegistry,
      private jreportDataService: JReportDataService,) {
        this.http$ = coreServiceRegistry.http$;
        localStorage.removeItem('HELPTABLEIDS');
      }

  public async ngOnInit() {
    this.initializeFeatureFlags();
    const [languagesResponse, countriesResponse] = await Promise.all([
      this.userService.getAllLanguages().toPromise(),
      this.userService.getEnabledCountries().toPromise(),
    ]);

    this.languages = languagesResponse;
    this.languages = this.languages.filter((lang: any) => {
      return lang.languageId !== this.userService.userInfo.defaultLanguage;
    });
    for (const language of languagesResponse) {
      if (language.languageId === this.userService.userInfo.defaultLanguage) {
        this.displayLanguage = language["name"];
        break;
      }
    }

    this.countries = countriesResponse;
    this.countries = this.countries.filter((cntry: any) => {
      return cntry.countryId !== this.userService.userInfo.defaultCountry;
    });
    for (const country of countriesResponse) {
      if (country.countryId === this.userService.userInfo.defaultCountry) {
        this.displayCountry = country["name"];
        break;
      }
    }
    //LFWM-5033 - Below code logic for checking whether the use has submitted feedback for the duration of 6 months and hiding based on the response on load
    // Attributes already set in initializeFeatureFlags()
    // Redirect to /preview if angular18-enabled-v0 flag is enabled
    if (gb.isOn('angular18-enabled-v0') && !window.location.pathname.startsWith('/preview')) {
      const previewUrl = `${window.location.origin}/preview${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.replace(previewUrl);
      return;
    }
    this.hiddenField = `country=${this.displayCountry}, browser=${getBrowser()}, language=${this.displayLanguage}`;

    this.isWMSFeatureEnabled = gb.isOn("sus-enabled-v0");
    this.isTMSFeatureEnabled = gb.isOn("sus-enabled-tms-v0");
    this.isMfaFeatureEnabled = gb.isOn('mfa-profile-enabled');
    const FEEDBACK_ID_WMS_DEFAULT = '1244624510694453248';
    const FEEDBACK_ID_TMS_FEATURE = '1237330305760620544';

    if (this.isWMSFeatureEnabled) {
      this.feedbackFormId = FEEDBACK_ID_WMS_DEFAULT;
    } else if (this.isTMSFeatureEnabled) {
      this.feedbackFormId = FEEDBACK_ID_TMS_FEATURE;
    }

    this.susEnabled = this.isTMSFeatureEnabled || this.isWMSFeatureEnabled;

    const feedbackBaseUrl = `https://insightshub-api.maersk-digital.net/api/feedbacks/${this.feedbackFormId}/author/`;
    this.emailAddress = this.userService.userInfo.emailAddress;
    if (this.emailAddress && this.emailAddress.trim() !== '') {
      const getIsFeedbackSubmittedAPIUrl = `${feedbackBaseUrl}${this.emailAddress}`;
        try {
            const response: any = await this.http$.get(getIsFeedbackSubmittedAPIUrl).toPromise();
            const now = new Date();
            const sixMonthsAgo = new Date(now.setMonth(now.getMonth() - 6));
            if (response.length === 0) {
                this.isFeedBackSubmitted = false;
            } else {
                const dateInput = new Date(response[0].created_at);
                this.isFeedBackSubmitted = dateInput >= sixMonthsAgo;
            }
        } catch (error) {
            this.isFeedBackSubmitted = false; 
        }
    } else {
        this.isFeedBackSubmitted = false;
    }
    
    // Start autorefresh timers for token expiry
    this.sessionTimerService.start();
    this.activatedRoute.params
      .subscribe(() => {
        this.navService.setPageTitle(this.resourceService.get('lbl_home'));
      });
    this.fetchRssFeeds();
    // this.carouselImageUrls = [ 'assets/images/carousel_1.min.png',
    //   'assets/images/carousel_2.min.png',
    //   'assets/images/carousel_3.min.png'];
    this.navigationSubscription = this.navService.getNavigatedMenuIdBroadcast()
      .subscribe((id: string) => {
        /* Subscribe to the navigation service so that whenever
          the menu id is changed, home page static content will be hidden */
        if (id === 'set_printer') {
            this.openPrinterSetupPopupForMenuClick();
        }
        if (id === 'home') {
          this.isHomePage = true;
          setTimeout(() => {
            if (this.isHomePage && this.isMfaFeatureEnabled) {
              this.showNoticeDialog();
            }
          }, 1000);
          
          // Update every 5minutes.
          this.updateFeedsTimer = Observable.interval(5000 * 60)
            .subscribe(() => this.fetchRssFeeds());
           //LFWM-2161 Trigger function to show down time notification to the loggedin user
            this.setDowntimeNotification();
            this.userService.showExpiryPopup();

        } else {
          this.isHomePage = false;
          if (this.updateFeedsTimer) {
            this.updateFeedsTimer.unsubscribe();
          }
        }
      });
      localStorage.removeItem('HELPTABLEIDS');
      let node = document.createElement('script');
      node.src ="../../../assets/jsscripts/insightshub.js";
      document.body.appendChild(node);

      this.browser = getBrowser();
      function getBrowser() {
        const userAgent = navigator.userAgent;
        let browser = "Unknown";

        if (userAgent.indexOf("Chrome") !== -1) {
          browser = "Chrome";
        } else if (userAgent.indexOf("Safari") !== -1) {
          browser = "Safari";
        } else if (userAgent.indexOf("Firefox") !== -1) {
          browser = "Firefox";
        } else if (
          userAgent.indexOf("MSIE") !== -1 ||
          userAgent.indexOf("Trident/") !== -1
        ) {
          browser = "IE";
        } else if (userAgent.indexOf("Edge") !== -1) {
          browser = "Edge";
        } else if (
          userAgent.indexOf("Opera") !== -1 ||
          userAgent.indexOf("OPR") !== -1
        ) {
          browser = "Opera";
        }

        return browser;
      }
  }
  /*
  Show notice dialog after translations are loaded
  */
  private showNoticeDialog(): void {
      let message = this.resourceService.get('msg_notice_stage');
      let title = this.resourceService.get('lbl_mfa_stage_notice_title');
      const notice = gb.getFeatureValue('mfa-enforcement-notice','msg_notice_stage');
      if (notice === "msg_notice_prod") {
        message = this.resourceService.get('msg_notice_prod');
        title = this.resourceService.get('lbl_mfa_prod_notice_title');
      }
     const modalRef: any = this.modalService
      .showModal(MfaNotificationPopupComponent,
        {
          overlayHeader:  title,
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 650
        });
    // If the user click Ok button, Seeting the isDowntimeInfoDisplayed as true and setting the value in userInfo .
    modalRef.content.initializeComponents(message);
    modalRef.content.receiveEvent()
      .subscribe((event: any) => {
        if (event.type === 'Ok') {
          
        }
        modalRef.hide();
      });
    modalRef.content.showLookup = true;
  }
  public ngAfterViewInit() {
  }

  // Method to fetch rss feeds
  private fetchRssFeeds() {
    //Temporary comment the code to unfetch rss feed
    /*this.rssFeedsSubscription = this.homeService.fetchRssFeed()
      .subscribe((rssData: any) => {
        this.rssFeeds = rssData.items;
      });*/
  }

  // Method used to resolve the labels from resource bundle
  public getLabel(key: string) {
    return this.resourceService.get(key);
  }

  public ngOnDestroy() {
    if (this.updateFeedsTimer) {
      this.updateFeedsTimer.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (this.rssFeedsSubscription) {
      this.rssFeedsSubscription.unsubscribe();
    }
  }

  public openPrinterSetupPopupForMenuClick() {
    this.modalService
      .showModal(PrinterSetupComponent,
        { overlayHeader: this.getLabel('lbl_default_rdt')
          + ' / ' + this.getLabel('lbl_Bartender_printer'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 1024
        });
  }

  /* This method initializes the date configuaration for date-picker/ calendar in ui-library dynamically after homepage is loaded.
   Updated with user specific configuration stored in UserService in core-library which is retrieved adn stored in userservice after login.

   #TODO-LIBRARY - doesnt work since datfomat is loaded in background after homepage loads.
   Might need to use some events. Currently directly injecting into sce-ui-lib dateconfigservice 
   from within sce-core userservice by using direct reference.
  */
  public setupGlobalDateTimeFormatForUser() {
  //  console.log('date setup')

  // this.dateConfigService.defaultDateDisplayFormat = this.userService.dateTimeConfig.defaultDateDisplayFormat;
  // this.dateConfigService.defaultTimeDisplayFormat = this.userService.dateTimeConfig.defaultTimeDisplayFormat;
  // this.dateConfigService.defaultTimeZone = this.userService.dateTimeConfig.defaultTimeZone;

  }
  // LFWM-3612- changed the code from user service to home component.
  public setDowntimeNotification() {
    const userInfo: UserInfo = this.appStorageService.getItem(KEYS_APPSTORAGE.USER_INFO);
    let msgList = [];
    let downTimeList = [];
    let today = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
    let sevenDaysFromToday = moment(today, "YYYY-MM-DD HH:mm:ss").add(7, 'days');
    if (!userInfo.isDowntimeInfoDisplayed) {
      this.userService.getUsersDownTimeNotifications().subscribe((response) => {
        if (response.statusCode === 200 && response.statusMessage === 'SUCCESS') {
          if (response.columnList.length > 0) {
            for (const record of response.columnList) {
              let formattedStartDate = moment(new Date(record.downTimeStart), "YYYY-MM-DD HH:mm:ss");
              let formattedEndDate = moment(new Date(record.downTimeEnd), "YYYY-MM-DD HH:mm:ss");
              // LFWM-2916- filtering the downtime having startdate greater than or equal to today and startdate less than 7 days from today.
              // and pushing into a new list.
              if ((formattedStartDate > today || formattedStartDate === today) && formattedStartDate < sevenDaysFromToday) {
                downTimeList.push(record);
              }
            }
          }
          // LFWM-2916-issue#3- sorting the display messages according to ascending order of date.
          downTimeList.sort((firstDate, secondDate) => {
            return new Date(firstDate.downTimeStart).getTime() - new Date(secondDate.downTimeStart).getTime();
          });
          // if there is any messages that need to be shown.
          if (downTimeList.length > 0) {
            this.showDownTimeNotification(downTimeList, userInfo)
          }
        } else {
          return false;
        }
      });
    }
  }
  // LFWM-3612- code to show the message popup.
  // giving the customClass as downTime, as some of the designs in existing modal is to changed.
  public showDownTimeNotification(downtimeList: any, userInfo: any) {
    const modalRef: any = this.modalService
      .showModal(MaintenanceNoticePopupComponent,
        {
          overlayHeader:  this.resourceService.get('lbl_scheduled_maintenance'),
          showHeader: true,
          overlayHeight: window.innerHeight,
          overlayWidth: 650,
          customClass: 'downTime'
        });
    modalRef.content.initializeComponents(downtimeList);
    // If the user click Ok button, Seeting the isDowntimeInfoDisplayed as true and setting the value in userInfo .
    modalRef.content.receiveEvent()
      .subscribe((event: any) => {
        if (event.type === 'Ok') {
          userInfo.isDowntimeInfoDisplayed = true;
          this.appStorageService.setItem(KEYS_APPSTORAGE.USER_INFO, userInfo);
        }
        modalRef.hide();
      });
    modalRef.content.showLookup = true;
  }

  /**
   * Initialize GrowthBook feature flags with user context
   * Sets user attributes for feature flag targeting
   */
  private initializeFeatureFlags(): void {
    try {
      const userInfo = this.userService.userInfo;
      if (userInfo) {
        gb.setAttributes({
          id: userInfo.userName,
          username: userInfo.userName,
          country: String(userInfo.defaultCountry),
          email: userInfo.emailAddress || '',
          userType: userInfo.userType || '',
          "deployment-region": environment.deploymentRegion ? environment.deploymentRegion : ''
        });
      }
    } catch (error) {
      console.warn('Failed to initialize GrowthBook feature flags:', error);
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/home.component.ts